import { transport } from 'config/transport';

export function callApiExportMamNonYearlyReport(congDoanId, academicYear, pdf = false) {
    return transport.get(`/mamnon/${congDoanId}/thuchi/exportReportAnnually`, { params: { academicYear, pdf }, responseType: 'blob' });
}
